import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M252.309-213.078q-12.423 0-20.827-8.396-8.403-8.396-8.403-20.807 0-12.411 8.403-20.834 8.404-8.423 20.827-8.423h455.382q12.423 0 20.827 8.396 8.403 8.396 8.403 20.807 0 12.411-8.403 20.834-8.404 8.423-20.827 8.423H252.309zm48.615-153.846q-21.839 0-32.304-19.076-10.465-19.077 1.766-37.154l179.691-268.768q10.889-16.461 29.944-16.461 19.056 0 29.902 16.461l179.691 268.768q12.231 18.077 1.766 37.154-10.464 19.076-32.304 19.076H300.924zM480-425.384zm-136.463 0h272.926L480-629.078 343.537-425.384z"
      ></path>
    </svg>
  );
}

export default Icon;
